// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Pp1i","colMin":"styles_colMin__2KVDY","colCheckbox":"styles_colCheckbox__3ub-L"};